import { Theme, ThemeTypes } from "@bitwarden/common/platform/enums";

/**
 * BracketsVault default theme for users who have not saved a preference yet.
 *
 * Revert to `ThemeTypes.System` when dark theme support is ready.
 */
export const BV_DEFAULT_THEME: Theme = ThemeTypes.Light;
